export default {
  DARK: 'DARK',
  LIGHT: 'LIGHT',
  AUTO: 'AUTO'
};